import { formatUtcDate } from 'App/services/DateService';

const UtcDateCell = ({ value }) => {
    return formatUtcDate({ date: value });
};

export default UtcDateCell;
